import { TS_Insurance }         from '../TravelSeller/Models/TS_Insurance';
import { BookingItemInterface } from './BookingItemInterface';

export class Insurance extends TS_Insurance implements BookingItemInterface {}